const BANNER_SELECTOR = '[class*="_banner_"]';

export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function getScrollBehavior(): ScrollBehavior {
  return prefersReducedMotion() ? "auto" : "smooth";
}

export function getStickyBannerHeight(): number {
  if (typeof document === "undefined") return 0;
  const banner = document.querySelector(BANNER_SELECTOR);
  return banner?.getBoundingClientRect().height ?? 0;
}

export function getScrollTargetForElement(element: HTMLElement): number {
  const elementTop = element.getBoundingClientRect().top + window.scrollY;
  return elementTop - getStickyBannerHeight();
}

export function scrollToElementById(elementId: string): boolean {
  if (typeof document === "undefined" || typeof window === "undefined") return false;

  const element = document.getElementById(elementId);
  if (!element) {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console -- dev-only diagnostic when scroll target is missing
      console.warn(`scrollToElementById: no element found for id "${elementId}"`);
    }
    return false;
  }

  window.scrollTo({
    behavior: getScrollBehavior(),
    top: getScrollTargetForElement(element),
  });

  return true;
}
